module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"error-500":{"headline":"Сайт закрыт на профилактические работы.","text":"На Manato.az ведутся плановые технические работы по улучшению сайта."}},"az":{"error-500":{"headline":"Sayt keçirilən planlı profilaktik işlərlə əlaqədar hazırda çalışmır.","text":"Manato.az saytın təkmilləşdirilməsi üçün planlı texniki işlər aparılır"}}}')
  delete Component.options._Ctor
}
